import React from 'react';
import { useSelector } from 'react-redux';

import { ModalCDS } from '@sharedCR/coreDesignSystem/Modals';

import { selectDialogs } from 'store/global/selectors';

import { dialogsTestIds } from '../dialogs.testIds';

const Dialogs = () => {
  const dialogs = useSelector(selectDialogs);

  return dialogs.map((dialog, index) => {
    const isLastModal = index === dialogs.length - 1;

    // We need to pass keepMounted for all modals except last one and pass open only for last one
    // in order to render Backdrop only once
    return (
      <ModalCDS
        key={dialog.id}
        {...dialog}
        dataTestId={dialogsTestIds.getModalTestId(dialog.id)}
        keepMounted={!isLastModal}
        open={isLastModal}
      />
    );
  });
};

export default Dialogs;
